module.exports = __webpack_public_path__ + "img/2021_10_dande_ninnaji_1011_fin_web.65a2baa1.png";